
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class BinaBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "BinaBildirimSave";
    super(baseUrl);
  }


  saveBinaBasvuruSave(request:any){
    
    return this.post("", request, true);
   
  }

}
export default new BinaBasvuruAPI();